export const TimePeriods = [
	{
	  value: "Weekdays Morning (8am – 11am)",
	  label: "Weekdays Morning (8am – 11am)",
	},
	{
	  value: "Week-Afternoons (12pm – 3pm)",
	  label: "Week-Afternoons (12pm – 3pm)",
	},
	{
	  value: "Week-Evening (5PM – 9PM)",
	  label: "Week-Evening (5PM – 9PM)",
	},
	{
	  value: "Saturdays Morning (8am – 11am)",
	  label: "Saturdays Morning (8am – 11am)",
	},
	{
	  value: "Saturday Afternoons (12pm – 3pm)",
	  label: "Saturday Afternoons (12pm – 3pm)",
	},
	{
	  value: "Saturday Evenings (5pm – 10pm)",
	  label: "Saturday Evenings (5pm – 10pm)",
	},
	{
	  value: "Sunday Afternoons (1pm – 4pm)",
	  label: "Sunday Afternoons (1pm – 4pm)",
	},
	{
	  value: "Sunday Evenings (5pm – 10pm)",
	  label: "Sunday Evenings (5pm – 10pm)",
	},
  ];

  export const Service = [
	{
	  value: "IT Essential: 2months Instructor led course",
	  label: "IT Essential: 2months Instructor led course",
	},
	{
	  value: "CompTIA A+: 3.5Months Instructor led",
	  label: "CompTIA A+: 3.5Months Instructor led",
	},
	{
	  value: "CompTIA Network+: 3.5Months Instructor led",
	  label: "CompTIA Network+: 3.5Months Instructor led",
	},
	{
	  value: "CompTIA Security+: 3.5Months Instructor led",
	  label: "WeekCompTIA Security+: 3.5Months Instructor led",
	}, 
	{
	  value: "CompTIA CySA+: 3.5Months Instructor led",
	  label: "CompTIA CySA+: 3.5Months Instructor led",
	},
	{
	  value: "CompTIA Linux+: 4months Instructor led",
	  label: "CompTIA Linux+: 4months Instructor led",
	},
	{
	  value: "CCNA: 4months Instructor led",
	  label: "CCNA: 4months Instructor led",
	},
	{
	  value: "Cisco Certified CyberOps Associate: 3months Instructor led",
	  label: "Cisco Certified CyberOps Associate: 3months Instructor led",
	},
	{
	  value: "CCNP: 4months Instructor led",
	  label: "CCNP: 4months Instructor led",
	},
	{
	  value: "AWS Cloud Practitioner: 6weeks Instructor led",
	  label: "AWS Cloud Practitioner: 6weeks Instructor led",
	},
	{
	  value: "AWS Solution Architect – Associate: 3.5Months Instructor led",
	  label: "AWS Solution Architect – Associate: 3.5Months Instructor led",
	},
	{
	  value: "AWS Solution Architect – Professional: 3.5Months Instructor led",
	  label: "WS Solution Architect – Professional: 3.5Months Instructor led",
	},
	{
	  value: "CISA: 3months Instructor led",
	  label: "CISA: 3months Instructor led",
	},
	{
	  value: "CRISC: 6weeks Instructor led",
	  label: "CRISC: 6weeks Instructor led",
	},
	{
	  value: "CISM: 5weeks Instructor led",
	  label: "CISM: 5weeks Instructor led",
	},
	{
	  value: "SSCP: 8weeks Instructor led",
	  label: "SSCP: 8weeks Instructor led",
	},
	{
	  value: "CAP: 7weeks Instructor led",
	  label: "CAP: 7weeks Instructor led",
	},
	{
	  value: "CISSP: 7weeks Instructor led",
	  label: "CISSP: 7weeks Instructor led",
	},
	{
	  value: "TOGAF ®",
	  label: "TOGAF ®",
	},
	{
	  value: "ITIL",
	  label: "ITIL",
	},
	{
	  value: "Microsoft Certified Professional (MCP)",
	  label: "Microsoft Certified Professional (MCP)",
	},
	{
	  value: "Microsoft Certified Solution Associate (MCSA)",
	  label: "Microsoft Certified Solution Associate (MCSA)",
	},
	{
	  value: "Azure Administration (AZ 104)",
	  label: "Azure Administration (AZ 104)",
	},
	{
	  value: "PMP",
	  label: "PMP",
	},
	{
	  value: "Prince2 ®",
	  label: "Prince2 ®",
	},
	{
	  value: "Website Design & Development Traning",
	  label: "Website Design & Development Traning",
	},
	{
	  value: "custom-request",
	  label: "Custom Request",
	},
	
  ];
  export const Serviceoffered = [
	{
	  value: "Cybersecurity and Audit Consulting Services ",
	  label: "Cybersecurity and Audit Consulting Services",
	},
	{
	  value: "I.T. Support Service",
	  label: "I.T. Support Service",
	},
	{
	  value: "Web Development and eCommerce Solutions",
	  label: "Web Development and eCommerce Solutions",
	},
	{
	  value: "I.T Training",
	  label: "I.T Training",
	}, 
	{
	  value: "Project Management",
	  label: "Project Management",
	},
	{
	  value: "Equipment Supplies and Maintenance",
	  label: "Equipment Supplies and Maintenance",
	},
	{
	  value: "Blockchain Applications",
	  label: "Blockchain Applications",
	},
	
  ];